import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TitleService } from './title.service';
import { Title } from '@angular/platform-browser';

export class SoftlineTitleStrategy extends TitleStrategy {
  constructor(
    protected environment: string,
    protected title: Title,
    protected service: TitleService
  ) {
    super();
    this.title.setTitle(environment);
  }

  override buildTitle(snapshot: RouterStateSnapshot): string | undefined {
    return super.buildTitle(snapshot);
  }

  override updateTitle(): void {
    if (this.service.title() !== '')
      return this.title.setTitle(`${this.service.title()} | ${this.environment}`);
    return this.title.setTitle(`${this.environment}`);
  }
}
